/**
 * BGN to EUR Price Updater
 * Updates EUR prices dynamically when variant prices change
 * Only active when market is "bulgaria"
 */

(function() {
  'use strict';

  // Check if we're on the Bulgaria market
  const isBulgariaMarket = document.body.classList.contains('template-product') || 
                          document.querySelector('[data-market-handle="bulgaria"]') ||
                          (window.Shopify && window.Shopify.locale && window.Shopify.locale.toLowerCase().includes('bg'));

  // Only proceed if we're on Bulgaria market
  // We'll check this more reliably by looking for price-eur elements
  const EUR_FACTOR = 1.95583;

  /**
   * Convert BGN price (in cents) to EUR and format it
   */
  function convertToEur(priceInCents) {
    if (!priceInCents || priceInCents === 0) return '';
    const priceInBgn = priceInCents / 100.0;
    const priceInEur = priceInBgn / EUR_FACTOR;
    const eurPriceFormatted = priceInEur.toFixed(2);
    return `(${eurPriceFormatted} €)`;
  }

  /**
   * Extract price in cents from variant object or element
   */
  function extractPriceFromElement(element, variant) {
    // If variant is provided, use it directly
    if (variant && variant.price) {
      return variant.price;
    }
    if (variant && variant.compare_at_price) {
      return variant.compare_at_price;
    }
    if (variant && variant.unit_price) {
      return variant.unit_price;
    }

    // Try to get price from data attribute
    const dataPrice = element.getAttribute('data-price-eur');
    if (dataPrice) {
      return parseInt(dataPrice, 10);
    }

    // Try to find parent with data-price-eur
    const parentWithPrice = element.closest('[data-price-eur]');
    if (parentWithPrice) {
      const price = parentWithPrice.getAttribute('data-price-eur');
      if (price) return parseInt(price, 10);
    }

    return null;
  }

  /**
   * Update EUR price for a given price element
   */
  function updateEurPrice(priceElement, priceInCents) {
    if (!priceElement) return;

    // Find or create EUR price element
    let eurElement = priceElement.querySelector('.price-eur');
    
    if (!eurElement) {
      // Check if there's a sibling EUR element
      const nextSibling = priceElement.nextSibling;
      if (nextSibling && nextSibling.classList && nextSibling.classList.contains('price-eur')) {
        eurElement = nextSibling;
      } else {
        // Create new EUR element
        eurElement = document.createElement('span');
        eurElement.className = 'price-eur';
        eurElement.setAttribute('data-price-eur', priceInCents);
        priceElement.appendChild(eurElement);
      }
    }

    if (eurElement) {
      const eurPrice = convertToEur(priceInCents);
      const eurValueElement = eurElement.querySelector('.price-eur__value') || eurElement;
      eurValueElement.textContent = eurPrice;
      eurElement.setAttribute('data-price-eur', priceInCents);
    }
  }

  /**
   * Update all EUR prices in a container
   */
  function updateAllEurPrices(container) {
    if (!container) container = document;

    // Update prices with data-regular-price attribute
    const regularPriceElements = container.querySelectorAll('[data-regular-price]');
    regularPriceElements.forEach(function(el) {
      const priceInCents = extractPriceFromElement(el);
      if (priceInCents) {
        updateEurPrice(el, priceInCents);
      }
    });

    // Update prices with data-sale-price attribute
    const salePriceElements = container.querySelectorAll('[data-sale-price]');
    salePriceElements.forEach(function(el) {
      const priceInCents = extractPriceFromElement(el);
      if (priceInCents) {
        updateEurPrice(el, priceInCents);
      }
    });

    // Update unit prices
    const unitPriceElements = container.querySelectorAll('[data-unit-price]');
    unitPriceElements.forEach(function(el) {
      const priceInCents = extractPriceFromElement(el);
      if (priceInCents) {
        updateEurPrice(el, priceInCents);
      }
    });
  }

  /**
   * Handle variant change events
   */
  function handleVariantChange(variant) {
    if (!variant) return;

    // Wait a bit for the theme to update prices first
    setTimeout(function() {
      const priceContainer = document.querySelector('[data-price]');
      if (!priceContainer) return;

      // Update regular price EUR
      const regularPriceEl = priceContainer.querySelector('[data-regular-price]');
      if (regularPriceEl) {
        const priceInCents = variant.price || extractPriceFromElement(regularPriceEl);
        if (priceInCents) {
          updateEurPrice(regularPriceEl, priceInCents);
        }
      }

      // Update sale price EUR
      const salePriceEl = priceContainer.querySelector('[data-sale-price]');
      if (salePriceEl) {
        const priceInCents = variant.price || extractPriceFromElement(salePriceEl);
        if (priceInCents) {
          updateEurPrice(salePriceEl, priceInCents);
        }
      }

      // Update compare at price EUR
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const comparePriceEl = priceContainer.querySelector('.price__sale .price-item--regular');
        if (comparePriceEl) {
          updateEurPrice(comparePriceEl, variant.compare_at_price);
        }
      }

      // Update unit price EUR
      if (variant.unit_price) {
        const unitPriceEl = priceContainer.querySelector('[data-unit-price]');
        if (unitPriceEl) {
          updateEurPrice(unitPriceEl, variant.unit_price);
        }
      }
    }, 50);
  }

  /**
   * Initialize the price updater
   */
  function init() {
    // Only run if we have price-eur elements (indicating Bulgaria market)
    const hasEurPrices = document.querySelectorAll('.price-eur').length > 0;
    if (!hasEurPrices) {
      // Check if we should add EUR prices (Bulgaria market check)
      const marketHandle = document.body.getAttribute('data-market-handle') || 
                          (window.Shopify && window.Shopify.market && window.Shopify.market.handle);
      
      if (marketHandle !== 'bulgaria') {
        return; // Not Bulgaria market, exit
      }
    }

    // Listen for variant change events (using the theme's event system)
    // The theme uses both Events (capital) and events (lowercase)
    if (typeof Events !== 'undefined') {
      Events.on('variantchange', function(variant) {
        handleVariantChange(variant);
      });
    }

    // Also try lowercase events (used in product forms)
    if (typeof window.theme !== 'undefined' && window.theme.Events) {
      window.theme.Events.on('variantchange', function(variant) {
        handleVariantChange(variant);
      });
    }

    // Listen for custom variantchange events
    document.addEventListener('variantchange', function(e) {
      if (e.detail && e.detail.variant) {
        handleVariantChange(e.detail.variant);
      } else if (e.detail) {
        handleVariantChange(e.detail);
      }
    });

    // Update EUR prices on cart updates
    if (typeof Events !== 'undefined') {
      Events.on('cart:updated', function() {
        setTimeout(function() {
          updateAllEurPrices();
        }, 100);
      });
    }

    // Use MutationObserver to watch for price changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Check if price elements were added or modified
          const target = mutation.target;
          if (target && (target.classList.contains('price-item') || 
                         target.hasAttribute('data-regular-price') || 
                         target.hasAttribute('data-sale-price'))) {
            const priceInCents = extractPriceFromElement(target);
            if (priceInCents) {
              updateEurPrice(target, priceInCents);
            }
          }
        }
      });
    });

    // Observe price containers
    const priceContainers = document.querySelectorAll('[data-price], .price, [data-cart-item-price]');
    priceContainers.forEach(function(container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    // Initial update
    setTimeout(function() {
      updateAllEurPrices();
    }, 500);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

